import React, { useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { setFocus, setFocusImmediate } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import GeneralButton from '../helpers/GeneralButton';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

import './FullPageQuizUI.css'
var currentQuestionIndx = 0;
var currentId: string =null;

const FullPageQuizUI = (props: UIProperties<FullPageQuizUIConfig>) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	const currentQuestion = props.parameters.questions[currentQuestionIndx];
	if(currentId) {
		setTimeout(() => {
			setFocusImmediate(currentId);
		}, 0);
	}
	return (
		<div className="in-game-ui-container ui-top-most-container modal-bg modal-disable-select">
			<div className="center-on-container fp-fade-in" style={{
				width: '88%',
				top: '52%'
			}} aria-label='evaluation'>
				<img src="./assets/images/general/components/full-page-quiz/window_evaluation.png"/>
				<div style={{
					position: 'absolute',
					top: '61px',
					left: '50%',
					width: '97%',
					height: '74px',
					transform: 'translate(-50%, 0)'
				}}>
					<p tabIndex={0} aria-label={`${(currentQuestionIndx + 1)} out of ${props.parameters.questions.length} questions. ${currentQuestion.title}`} id='first-object-fullPageQuiz' className="title-font" style={{
						position: 'absolute',
						top: '50%',
						left: '20px',
						margin: 0,
						transform: 'translate(0, -50%)',
						fontSize: '25pt',
						fontWeight: 'normal',
						width: '96%'
					}}>{currentQuestion.title}</p>
				</div>
				<hr style={{
					    width: '99.8%',
						height: '4px',
						backgroundColor: 'rgb(171, 172, 179)',
						position: 'absolute',
						top: '146px',
						left: '1px'
				}} />
				
				<div style={{
					position: 'absolute',
					top: '170px',
					left: '36%',
					transform: 'translate(-50%, 0)',
					width: '1170px',
					height: '429px',
					padding: '0px',
					overflow: 'auto'
				}}>
					{currentQuestion.options.map((o: FullPageQuizOption, oIndex: number) => {
						const baseUrl = './assets/images/general/components/sbar/';
						const extension = '.png';

						const state_button_answer_small_main = 'button_answer_main';
						const state_button_answer_small_down = 'button_answer_down';

						const state_button_answer_med_main = 'button_answer_main_med';
						const state_button_answer_med_down = 'button_answer_down_med';

						const state_button_answer_large_main = 'button_answer_main_lg';
						const state_button_answer_large_down = 'button_answer_down_lg';

						const smallCharCount = 14;
						const medCharCount = 22;

						const getBg = () => {
							if(o.title.length <= smallCharCount) {
								return state_button_answer_small_main;
							} else if(o.title.length <= medCharCount) {
								return state_button_answer_med_main;
							} else {
								return state_button_answer_large_main;
							}
						}

						const getBgHighlight = () => {
							if(o.title.length <= smallCharCount) {
								return state_button_answer_small_down;
							} else if(o.title.length <= medCharCount) {
								return state_button_answer_med_down;
							} else {
								return state_button_answer_large_down;
							}
						}

						const getBgWidth = () => {
							if(o.title.length <= smallCharCount) {
								return 285.33;
							} else if(o.title.length <= medCharCount) {
								return 425.33;
							} else {
								return 615.33;
							}
						}

						const getCustomTextStyle = () => {
							var margin = 66;

							return {
								width: (getBgWidth() - margin) + 'px',
								marginLeft: margin + 'px',
								textAlign: 'left',
								left: '0',
								transform: 'translate(0, -50%)'
							}
						}

						var bttnId = currentQuestion.options.filter(o => o.isSelected).length === 0 && oIndex === currentQuestion.options.length - 1 && !currentQuestion.left && !currentQuestion.center && !currentQuestion.right ? 'last-object-fullPageQuiz' : ('eval-q-o-' + oIndex);

						return(
							<div style={{
								position: 'relative',
							}} key={Tools.generateGuid()}>
								<div style={{
									position: 'relative',
									left: '10px',
									width: getBgWidth() + 'px',
									height: '65px',
									pointerEvents: 'all',
								}}>
									<GeneralButtonWithText parameters= {{
										onKeyUp:(e) => {
											if (e.key === 'Tab' || e.which === 9) {
												currentId = bttnId

												if(e.shiftKey) {
													if(oIndex - 1 < 0) {
														currentId = null
													}
												} else {
													if(oIndex + 1 > currentQuestion.options.length - 1) {
														currentId = null
													}
												}
											}
										},
										id: bttnId,
										ariaLbl: o.title + '. ' + (currentQuestion.options[oIndex].isSelected ? 'selected. ' : 'not selected. '),
										srcIdle: baseUrl + getBg() + extension,
										srcHighlight: baseUrl + getBgHighlight() + extension,
										shouldLeaveOn: o.isSelected,
										top: '0',
										left: '0',
										width: getBgWidth() + 'px',
										highlightOnHover: false,
										text: o.title,
										customImgStyle: {
											maxWidth: 'unset',
											width: '100%',
											height: '100%'
										},
										customBttnStyle: {
											width: '100%'
										},
										customTextStyle: getCustomTextStyle(),
										onClicked: () => {
											if(typeof currentQuestion.options[oIndex].isSelected === 'undefined') {
												currentQuestion.options[oIndex].isSelected = false;
											}

											if(!currentQuestion.multipleChoice) {
												for(var p= 0; p < currentQuestion.options.length; p++) {
													currentQuestion.options[p].isSelected = false;
												}
											}
											
											currentQuestion.options[oIndex].isSelected = !currentQuestion.options[oIndex].isSelected;
											setForceUpdate(!forceUpdate);
											setFocus('eval-q-o-' + oIndex);
										}
									}}/>
								</div>
							</div>
						);
					})}

					<div className="fp-question-container" style={{
						top: currentQuestion.leftTop
					}}>
						{currentQuestion.left ? (<div className="fp-left-content">
							<p className="regular-description-font" id={currentQuestion.options.filter(o => o.isSelected).length === 0 && !currentQuestion.center && !currentQuestion.right ? "last-object-fullPageQuiz" : "fpq-leftText"} tabIndex={currentQuestion.leftText ? 0 : -1} onKeyUp={(e) => {
								if (e.key === 'Tab' || e.which === 9) {
									currentId = document.activeElement.id;
								}
							}} dangerouslySetInnerHTML={{ __html: currentQuestion.leftText}}></p>
						</div>) : (<div></div>)}
						{currentQuestion.center ? (<div className="fp-center-content">
							<p className="big-description-font" id={currentQuestion.options.filter(o => o.isSelected).length === 0 && !currentQuestion.right ? "last-object-fullPageQuiz" : 'fpq-center-text'}  onKeyUp={(e) => {
								if (e.key === 'Tab' || e.which === 9) {
									currentId = document.activeElement.id;
								}
							}} tabIndex={currentQuestion.centerText ? 0 : -1} dangerouslySetInnerHTML={{ __html: currentQuestion.centerText}}></p>
						</div>) : (<div></div>)}
						{currentQuestion.right ? (<div>
							<div className="fp-left-img">
							<img src={"./assets/images/general/components/full-page-quiz/imgs/" + currentQuestion.leftImg + ".png"}/>
							</div>
							<div className="fp-right-content">
								<p tabIndex={currentQuestion.rightText ? 0 : -1}  onKeyUp={(e) => {
									if (e.key === 'Tab' || e.which === 9) {
										currentId = document.activeElement.id;
									}
							}} id= {currentQuestion.options.filter(o => o.isSelected).length === 0 ? "last-object-fullPageQuiz" :'fpq-right-text'} className="regular-description-font" dangerouslySetInnerHTML={{ __html: currentQuestion.rightText}}></p>
							</div>
						</div>) : (<div></div>)}
					</div>
				</div>

				<hr style={{
					position: 'absolute',
					top: '790px',
					left: '1px',
					width: '99.8%',
					backgroundColor: 'rgb(171, 172, 179)',
					height: '2px'
				}} />

				<div style={{
					position: 'absolute',
					top: '800px',
					left: '0'
				}}>
					{props.parameters.questions.map((q: FullPageQuizQuestion, index: number) => {

						const baseUrl = './assets/images/general/components/full-page-quiz/';
						const extension = '.png';
						var img = '';

						if(index > 0) {
							if(currentQuestion === q) {
								img = 'tab_evalutation_3';
							} else {
								img = 'tab_evalutation_2';
							}
						} else {
							if(currentQuestion === q) {
								img = 'tab_evalutation_1_down';
							} else {
								img = 'tab_evalutation_1';
							}
						}

						return (
							<div key={Tools.generateGuid()} style={{
								width: '100px',
								display: 'inline-block',
								position: 'relative',
								left: '-' + (19 * index) + 'px' 
							}}>
								<img style={{
									filter: index > currentQuestionIndx ? 'brightness(50%)' : 'brightness(100%)' 
								}} src={baseUrl + img + extension} alt="" />
								{index < currentQuestionIndx ? <img style={{
									position: 'absolute',
									top: '50%',
									left: '50%',
									width: '40px',
									transform: 'translate(-50%, -50%)'
								}} src={baseUrl + 'checkmark_2' + extension} alt="" /> : (null)}
							</div>
						)
					})}
				</div>

				<hr style={{
					position: 'absolute',
					top: '861px',
					left: '1px',
					width: '99.8%',
					backgroundColor: 'rgb(171, 172, 179)',
					height: '2px'
				}} />

				<div style={{
					position: 'absolute',
					top: '899px',
					width: '100%',
					height: '62px'
				}}>
					<GeneralButtonWithText parameters= {{
						id: 'last-object-fullPageQuiz',
						isNotTabbable: currentQuestion.options.filter(o => o.isSelected).length === 0,
						onKeyUp:(e) => {
							if (e.key === 'Tab' || e.which === 9) {
								currentId = document.activeElement.id;
							}
						},
						srcIdle: './assets/images/general/components/sbar/button_submitToPatientRecord.png',
						srcHighlight: './assets/images/general/components/sbar/button_submitToPatientRecord.png',
						highlightOnHover: true,
						text: 'SUBMIT TO PATIENT RECORD',
						isDisabled: currentQuestion.options.filter(o => o.isSelected).length === 0,
						srcDisabled: './assets/images/general/components/sbar/button_submitToPatientRecord.png',
						top: '0px',
						left: '36%',
						width: '407.33px',
						customImgStyle: {
							maxWidth: 'unset',
							width: '100%',
							height: '100%',
							filter: currentQuestion.options.filter(o => o.isSelected).length === 0 ? 'brightness(50%)' : 'brightness(100%)' 
						},
						customTextStyle: {
						},
						onClicked: () => {
							if(props.parameters.onSingleQuestionSubmitted) {
								if(props.parameters.onSingleQuestionSubmitted(currentQuestion)) {
									currentId = undefined;
									if(currentQuestionIndx + 1 < props.parameters.questions.length) {
										currentQuestionIndx++;
										setForceUpdate(!forceUpdate);

										setFocus('first-object-main'); //read score

										setTimeout(() => {
											setFocus('first-object-fullPageQuiz');
										}, 250);
										
									} else {
										if(props.parameters.onDone) {
											currentQuestionIndx = 0;
											setFocus('first-object-main');
											setTimeout(() => {
												props.parameters.onDone();
											}, 100);
										}
									}
								}
							}
						}
					}}/>
				</div>
			</div>
		</div>
	);

};

export interface FullPageQuizUIConfig extends BaseConfig {
	questions: FullPageQuizQuestion[];
	onSingleQuestionSubmitted: (question: FullPageQuizQuestion) => boolean;
	onDone: () => void;
}

export interface FullPageQuizQuestion {
	title: string;
	options: FullPageQuizOption[];
	multipleChoice?: boolean;
	incorrectFeedback: string;
	left?: boolean;
	leftText?: string;
	leftTop?: string;
	right?: boolean;
	rightText?: string;
	rightTop?: string;
	leftImg?: string;
	center?: boolean;
	centerText?: string;
}

export interface FullPageQuizOption {
	title: string;
	isCorrect: string;
	isSelected?: boolean;
	isRrt?: boolean;
	isProv?: boolean;
	isFail?: boolean;
	points: number;
}

export default FullPageQuizUI;